// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  LIFECYCLE_DATE_LAG_HEX,
  LIFECYCLE_INVOICE_REVIEW_HEX,
} from '@/billing/constants/lifecycle-segment-colors';
import type { FulfillmentCycleTimeReport } from '@/fulfillment/api/types';
import type { CycleTimeSegment } from '@/report/components/cycle-time-metrics';

type FulfillmentCycleTimeMetricKey = keyof Pick<
  FulfillmentCycleTimeReport,
  | 'createdToOpened'
  | 'openToFirstShipmentShipped'
  | 'firstShipmentShippedToClose'
>;

export const CYCLE_TIME_SEGMENTS: CycleTimeSegment<FulfillmentCycleTimeMetricKey>[] =
  [
    {
      key: 'createdToOpened',
      label: 'Drafted to opened',
      tooltip: 'Time from fulfillment order creation to first action',
      color: LIFECYCLE_INVOICE_REVIEW_HEX,
    },
    {
      key: 'openToFirstShipmentShipped',
      label: 'Open to first shipment shipped',
      tooltip: 'Time from first action to first linked shipment shipped',
      color: 'success.main',
    },
    {
      key: 'firstShipmentShippedToClose',
      label: 'First shipment shipped to close',
      tooltip: 'Time from first linked shipment shipped to order close',
      color: LIFECYCLE_DATE_LAG_HEX,
    },
  ];
